'use strict'
import router from '@/router'
import api from '@/api/api'
import notify from "@/utils/notify";
import userService from "@/api/userService";
import organizationService from "@/api/organizationService";
import {encrypt, decrypt} from "@/utils/crypto";
import activityWatcher from "@/utils/activityWatcher";
import subscriptionService from "@/api/subscriptionService";

export default {

  async userLogin(json) {
    const data = {
      method: 'post',
      url: 'login',
      body: json,
    }

    const response = await api.api(data)
    this.processAccessResponse(response, json.email)
  },

  processAccessResponse(response, email) {
    if (response.status === 200) {
      notify.alert.success('OTP sent to your email')
      sessionStorage.setItem('email', email)
      sessionStorage.setItem('otp', '60')
      router.push('/verify-otp')
    } else if (response.status === 201) {
      notify.alert.success('First time login. Your password has been sent to your email.')
      router.push('/employee-login')
    } else if (response.status === 401) {
      notify.alert.error(response.data.message)
      router.push('/employee-login')
    }
  },

  async verifyOTP(json) {
    const data = {
      method: 'post',
      url: 'verify-otp',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      sessionStorage.setItem('access_token', encrypt(response.data.access_token))
      sessionStorage.setItem('logged_in', encrypt('true'))
      sessionStorage.removeItem('email')
      let profile = await userService.getProfile('employee')
      if (profile.organization_id === null) {
        router.push('/create-organization')
      } else {
        await organizationService.getOrganization()
        await subscriptionService.getSubscription()
        activityWatcher()
        notify.alert.success('Login Successful')
        router.push('/dashboard')
      }
    } else if (response.status === 401) {
      notify.alert.error(response.data.message)
      router.push('/verify-otp')
    }
  },

  async SSOAuth(token) {
    const data = {
      method: 'get',
      url: 'profile',
    }

    const response = await api.api(data, token)
    if (response.status === 200) {
      sessionStorage.clear();
      sessionStorage.setItem('access_token', encrypt(token))
      sessionStorage.setItem('logged_in', encrypt('true'))
      await userService.getProfile()
      await organizationService.getOrganization()
      await subscriptionService.getSubscription()
      activityWatcher()
      notify.alert.success('Login Successful')
      await router.push('/dashboard')
    } else {
      await router.push('/login')
    }
  },

  async userLogout() {
    let profile = JSON.parse(decrypt(sessionStorage.getItem('profile')))
    let route = profile.role === 'employee' ? '/employee-login' : '/logout'
    const data = {
      method: 'post',
      url: 'logout',
    }

    const response = await api.api(data)
    if (response.status === 200 || response.status === 401) {
      sessionStorage.clear();
      notify.alert.info('Logout Successful')
      window.location.href = route
    }
  },

  async resetPassword(json) {
    const data = {
      method: 'post',
      url: 'reset-password',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Password reset successful. Please check your email.')
      router.push('/update-password/' + json.email)
    }

    return response
  },

  async requestOTP(json) {
    const data = {
      method: 'post',
      url: 'request-otp',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      sessionStorage.setItem('otp', '60')
      notify.alert.success('OTP successfully sent. Please check your email.')
      return true
    }
  },

  async updatePassword(json) {
    const data = {
      method: 'post',
      url: 'update-password',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      notify.alert.success('Password successfully updated. Please login.')
      router.push('/login')
    } else if (response.status === 401) {
      notify.alert.error(response.data.message)
    }
  },
}
